import { gql } from '@apollo/client'

const DUPLICATE_MENU_CURATION_TASK_MUTATION = gql`
  mutation duplicateMenuCurationTaskMutation($id: ID!, $customName: String) {
    duplicateMenuCurationTask(id: $id, customName: $customName) {
      id
      menu {
        id
        brand {
          id
          name
        }
      }
    }
  }
`

export default DUPLICATE_MENU_CURATION_TASK_MUTATION
